import React from 'react';

import {
    RequestIdWithWarning,
    replaceRequestId,
    RequestDays,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
import { DefineDate } from '../../components/utilities/Table/generalColumns/DefineDate';

const commonColumns = [
    RequestIdWithWarning('gestionsolicitud.fecha_comite'),
    RequestDays('gestionsolicitud.fecha_creacion'),
    {
        Header: 'Fecha Aprobación',
        accessor: 'gestionsolicitud.fecha_comite',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: () => 'Concesionario',
        id: 'aliado',
        Cell: ({ row }) => {
            return (
                <div>
                    {row.original?.concesionario?.label
                        ? row.original?.concesionario?.label
                        : 'SIN CONCESIONARIO'}
                </div>
            );
        },
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    {
        Header: () => 'Pagaré electrónico',
        id: 'codigo_deceval',
        Cell: ({ row }) => {
            return (
                <div>
                    {row.original?.firma_electronica_deceval ? 'SI' : 'NO'}
                </div>
            );
        },
    },
];

const requestsListStatus = [
    {
        id: 'bolsa_general_cartera',
        label: 'EN BOLSA GENERAL',
        status: 50,
        responsable: false,
        offices: true,
        columns: commonColumns.filter((item) => item.id !== 'codigo_deceval'),
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'en_proceso_cartera',
        label: 'EN PROCESO',
        status: 50,
        responsable: true,
        offices: true,
        columns: commonColumns,
    },
    {
        id: 'procesadas_cartera',
        label: 'PROCESADAS',
        status: false,
        offices: true,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 50,
                operator: '%26',
            },
            {
                name: 'gestionsolicitud__usuario_legalizacion',
                value: 'user',
                operator: '|',
            },
            {
                name: 'gestionsolicitud__usuario_desistimiento',
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(
                    1,
                    2,
                    DefineDate('legalizacion', 'Fecha Legalización')
                );
                cols.splice(8, 0, StatusWithTooltip);
                cols.splice(9, 0, CausalRequest);
                return cols;
            })()
        ),
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
